import React, { useState, useEffect } from "react";
import clinicService from "../../../../../services/clinic.service";
import { useParams } from "react-router-dom";
import NewReputation from "./NewReputation";
import Links from "./Links";
import CommentsTable from "./CommentsTable";
import FeedbackTable from "./FeedbackTable";
function ReputationTab() {
  /**
    Check if there is reputation enabled or not 
    Create a reputation with url or short code 


  */
  const [isEditing, setIsEditing] = useState(false);
  const {clinicId} = useParams()
  const [hasReputationService,setHasReputationService] = useState(false)
  const [shortCode,setShortCode] = useState(null)

  useEffect(()=>{
    checkReputationService()
  },[clinicId])

  const checkReputationService = ()=>{
      clinicService.getReputationClinic(clinicId)
      .then(res=>{
          setShortCode(res.data.shortCode)
          setHasReputationService(true)
      })
      .catch(error=>{
        setHasReputationService(false)
      })
  }
  return (
    <>
      <h5 className="card-title" style={{ color: "#012970" }}>
        
        Reputation Enhancements
      </h5>
       {!hasReputationService ? <>
          <NewReputation clinicid={clinicId} checkReputationService={checkReputationService}/>
       </> : <>
      
         <div className="row">
          <div className="col-auto">
              <span className="h5">Short Code :</span>
            </div>
            <div className="col-auto">
              <input type="text" className="form-control" disabled value={shortCode}/>
              
          </div>
         </div>
          <Links clinicid={clinicId}/>
          <CommentsTable clinicid={clinicId}/>
          <FeedbackTable clinicid={clinicId}/>
       </>}

    </>
  );
}

export default ReputationTab;
